var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register"},[_c('TopLogo'),_c('div',{staticClass:"register-tab"},[_c('MusicType',{attrs:{"width":952,"type":_vm.type,"tabsList":_vm.tabsList,"dropdownList":_vm.dropdownList}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }